import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { Outlet } from "react-router-dom";

import Header from "../../../components/Header/Header";

const HeaderLayout = (): JSX.Element => {
  const theme = useTheme();
  return (
    <>
      <Header />
      <Stack
        sx={{
          margin: 4,
          height: "calc(100vh - 64px - 64px)",
          [theme.breakpoints.down(780)]: {
            margin: 1,
            height: "calc(100vh - 64px - 16px)"
          }
        }}>
        <Outlet />
      </Stack>
    </>
  );
};

export default HeaderLayout;
